<div class="address-form-container" *transloco="let t;">
    <div class="header-wrapper">
        <span class="form-title">{{t('modals.add_address_modal.add_new_address')}}</span>
        <button class="button-undecorated close-button" [attr.aria-label]="'Close ' + t('modals.add_address_modal.add_new_address')"
            (click)="closeModal()">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    <div class="address-form-wrapper">
        <cwo-address-form #addressFormComponent
            [isAccountPage]="true"
            [isAddressBook]="isAdressBook"
            [validationResponse]="validationResponse"
            (isFormValid)="handleAddressFormValidation($event)"
            (overrideAddress)="handleOverrideAddress()"
            (noThankYou)="handleNoThankyou()"
            (formChanging)="handleFormChanging()"
            [allErrors]="serverErrors"
        />
    </div>
    <div class="button-container">
        <button class="button-accent submit-button" (click)="onSubmit()">
            {{t('modals.add_address_modal.done')}}
        </button>
    </div>
</div>